<page
  name="dashboard.documents"
  description="settings.documentsDesc"
  headerType="h2"
  [productBadges]="productBadges"
>
  <div class="tw-mb-5">
    <ul class="p-tab">
      <li
        class="p-tab__item max-lg:tw-flex-1 max-lg:tw-text-center"
        [class.active]="selectedTab === 'statements'"
      >
        <a class="p-tab__link" [routerLink]="['/dashboard/statements-reports']">{{
          'settings.statementsCertificates' | translate
        }}</a>
      </li>
      <li
        class="p-tab__item max-lg:tw-flex-1 max-lg:tw-text-center"
        [class.active]="selectedTab === 'reports'"
      >
        <a
          class="p-tab__link"
          [routerLink]="['/dashboard/statements-reports']"
          [queryParams]="{ selectedTab: 'reports' }"
          >{{ 'settings.reports' | translate }}</a
        >
      </li>
    </ul>
  </div>

  @if (selectedTab === 'statements') {
    <app-statements></app-statements>
  }
  @if (selectedTab === 'reports') {
    <app-reports></app-reports>
  }
</page>
